const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/mailvotes/pricing`
  : (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5005/api/mailvotes/pricing'
    : 'https://doorknockserver-280072100489.us-central1.run.app/api/mailvotes/pricing');

export async function fetchQuote(count) {
  const res = await fetch(`${API_BASE}/quote?count=${encodeURIComponent(count)}`);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Pricing service returned ${res.status}`);
  }
  return res.json();
}

export async function fetchTiers() {
  const res = await fetch(`${API_BASE}/tiers`);
  if (!res.ok) throw new Error(`Pricing service returned ${res.status}`);
  return res.json();
}

export default { fetchQuote, fetchTiers };
